import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bfd-transaction-table',
  templateUrl: './transaction-table.component.html',
  styleUrls: ['./transaction-table.component.scss']
})
export class TransactionTableComponent {
  @Input() data: any[] = [];
  @Input() showSaldo = true;
  @Input() tableOrigin!: string;
  @Output() dataEmitter: EventEmitter<any> = new EventEmitter<any>();

  public loading = false;

  public limitIncrease(event): void {
    this.loading = !this.loading;
  }

  public getBalanceDetails(balance, date?): void {
    if(date) {
      balance = {...balance, data: date};
    }
    this.dataEmitter.emit(balance);
  }
}